/**
 * The trade-in flow is a DYNAMIC, ordered list of steps:
 *
 *   Items  →  [Your story]  →  Details  →  Shipping  →  Confirm
 *
 * "Your story" is brand-gated (config.storyStep). Payout is removed. This mirrors the
 * redesign spec §5 — steps are *contributed*, not hard-coded, so hiding one adjusts the
 * stepper and indices automatically.
 */

export interface StepDef {
  id: string
  path: string
  /** Translation key for the stepper label (e.g. 'steps.items'). */
  label: string
}

export interface FlowConfig {
  /** Brand enables the optional "Your story" step (existing `tradeInComments`). */
  storyStep: boolean
}

export function buildSteps(config: FlowConfig): StepDef[] {
  const steps: StepDef[] = [{ id: 'items', path: 'items', label: 'steps.items' }]

  if (config.storyStep) {
    steps.push({ id: 'story', path: 'story', label: 'steps.story' })
  }

  steps.push(
    { id: 'details', path: 'details', label: 'steps.details' },
    { id: 'shipping', path: 'shipping', label: 'steps.shipping' },
    { id: 'confirm', path: 'confirm', label: 'steps.confirm' },
  )

  return steps
}
